// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__TfNi9","paramInput":"JobSimulator_paramInput__3UQgx","input":"JobSimulator_input__2k7Ub"};